// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/3d1bf34fcfd2b6456185.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e5ac888965a3de98a347","154":"eb2baa38f79f08b2eb4e","155":"4550654a2db0f87a6550"}[chunkId] + ".chunk.js";
};